


(function ($) {
    $(function () {

        function drawResponsiveTable($table) {
            let headers = {};

            if ($table.parent().hasClass('wptb-table-container')) {
                if ($table.hasClass('wptb-header-first-row')) {
                    headers = drawResponsiveTableHeader($table, 'tbody tr:first-child td'); // Table Builder plugin
                }
            } else {
                headers = drawResponsiveTableHeader($table, 'thead th'); // Simple tables
            }

            $table.find('td').each(function (index) {
                let $cell = $(this).children('.cell');
                if (!$cell.length) {
                    $(this).wrapInner('<div class="cell"></div>')
                }
            });

            if (!$.isEmptyObject(headers)) {
                drawResponsiveTableCells($table, 'tbody tr', headers);
            }
        }

        function drawResponsiveTableCells($table, rowSelector, headers) {
            if (headers === undefined) {
                headers = {};
                $table.find('thead th').each(function (index) {
                    headers[index] = $(this).text();
                });
            }

            if (rowSelector === undefined) {
                rowSelector = 'tbody tr';
            }

            if (!$.isEmptyObject(headers)) {
                if ($table.parent().hasClass('wptb-table-container') && $table.hasClass('wptb-header-first-row')) {
                    rowSelector += ':not(:first-child)';
                }
                $table.find(rowSelector).each(function () {
                    $(this).find('td').each(function (index) {
                        let $td = $(this);
                        let $cell = $td.children('.cell');
                        if (!$cell.length) {
                            $cell = $td.wrapInner('<div class="cell"></div>').children('.cell');
                        }
                        let alreadyWrapped = $cell.children('.table-cell-content');
                        if (!alreadyWrapped.length) {
                            $cell.wrapInner('<div class="table-cell-content"></div>');
                            if (headers[index]) {
                                $cell.prepend('<span class="table-cell-header">' + headers[index] + '</span>');
                            }
                        }
                    });
                });
            }
        }

        function drawResponsiveTableHeader($table, headerSelector) {
            let headers = {};
            $table.find(headerSelector).each(function (index) {
                let $th = $(this);
                $th.addClass('js-table-column-sorter');
                let $cell = $th.children('.cell');
                if (!$cell.length) {
                    $cell = $th.wrapInner('<div class="cell"></div>').children('.cell');
                }

                let alreadySorter = $cell.children('.sorter');
                if (!alreadySorter.length) {
                    $cell.append('<span class="sorter"></span>');
                }

                headers[index] = $(this).text();
            });

            return headers;
        }

        const initTables = () => {
            $('table:not(.ioe)').each(function () {
                drawResponsiveTable($(this));
            });
        }

        const init = () => {
            console.log("tables-------------------js");

            initTables()
            window.drawResponsiveTable = drawResponsiveTable;
        }

        init();
    });
})(jQuery, window, document);
